// Component: SurveyProcessingModal
// Purpose: Modal displayed during video compression and upload process

import React from 'react';
import { X } from 'lucide-react';
import { ButtonSpinner } from '../../../components/ui/feedback/loading-spinner.jsx';

// Processing states
export const PROCESSING_STATE = {
  IDLE: 'idle',
  COMPRESSING: 'compressing',
  UPLOADING: 'uploading'
};

export const SurveyProcessingModal = ({ 
  isUploading, 
  cancelUpload, 
  currentProcessingStep, 
  compressionProgress, 
  uploadProgress 
}) => {
  if (!isUploading) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full mx-4 text-center relative">
        {/* Close button */}
        <button 
          onClick={cancelUpload}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        
        <div className="flex flex-col items-center justify-center">
          {/* Processing Icon */}
          <div className="relative mb-4">
            <div className="flex items-center justify-center">
              <ButtonSpinner color="primary-600" className="h-10 w-10" />
            </div>
          </div>
          
          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {currentProcessingStep === PROCESSING_STATE.COMPRESSING 
              ? 'Optimizing video...' 
              : 'Uploading video...'}
          </h3>
          
          {/* Description */}
          <p className="text-gray-600 mb-6">
            {currentProcessingStep === PROCESSING_STATE.COMPRESSING
              ? 'Please wait while we optimize your video for faster upload'
              : 'Please be patient as we upload your video response.'}
          </p>
          
          {/* Progress Bar - hidden from user but kept for internal tracking */}
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2" style={{ display: 'none' }}>
            <div 
              className="bg-primary-600 h-2.5 rounded-full transition-all duration-300" 
              style={{ 
                width: `${currentProcessingStep === PROCESSING_STATE.COMPRESSING 
                  ? compressionProgress 
                  : uploadProgress}%` 
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};


